// Icônes sobres pour les alertes du cockpit (panneau "À faire aujourd'hui").
// Historiquement le socle du système d'icônes ; les tracés vivent désormais
// dans Icon.jsx (système générique du cockpit). AlertIcon reste un alias
// stable pour les appelants existants (AnissaDashboard) — même API.
import Icon from './Icon';

export default function AlertIcon(props) {
  return <Icon {...props} />;
}
